class ProductComparisonTable extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

  }

  setupListeners () {
    super.setupListeners()

    this.els['view-switcher'].element.addEventListener('change', (e) => {
      this.viewSwitcherChanged.bind(this)(e)
    })

    this.addEventListener('scroll', () => {
      if (this.scrollLeft > 0) {
        this.classList.add('sec-ProductComparisonTable-scrolled')
      } else {
        this.classList.remove('sec-ProductComparisonTable-scrolled')
      }
    });
  }

  viewSwitcherChanged (e) {
    const modelViewImages = this.els['model-image'].elements
    const productViewImages = this.els['product-image'].elements

    modelViewImages.forEach(img => img.setAttribute('aria-hidden', !e.target.checked))
    productViewImages.forEach(img => img.setAttribute('aria-hidden', e.target.checked))

    this.els['view-label'].elements.forEach(label => {
      label.classList.toggle('sec-ProductComparisonTable_ViewSwitcherLabel-active')
    })
  }
}

if (!customElements.get('product-comparison-table')) {
  customElements.define('product-comparison-table', ProductComparisonTable)
}
